"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupTimezone = setupTimezone;
exports.getValidLocale = getValidLocale;
exports.momentLocaleMapper = momentLocaleMapper;
exports.getLangEnabledLocales = getLangEnabledLocales;
exports.setManualOverwrites = setManualOverwrites;
exports.setHtmlLang = setHtmlLang;
exports.momentMappings = exports.languageMappings = exports.defaultLanguage = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _I18n = _interopRequireDefault(require("I18n"));

var _getLangLocale = _interopRequireDefault(require("../../utils/getLangLocale"));

var _getLang = _interopRequireDefault(require("../../utils/getLang"));

var defaultLanguage = 'en'; // Keys that should map from one to another specific locale

exports.defaultLanguage = defaultLanguage;
var languageMappings = {
  nb: 'no-no',
  noNO: 'no-no',
  'zh-tw': 'zh-hk',
  pt: 'pt-br',
  no: 'no-no',
  ca: 'ca-es',
  ar: 'ar-eg'
};
exports.languageMappings = languageMappings;
var momentMappings = {
  pt: 'pt-br',
  'en-ie': 'en-gb',
  'en-nz': 'en-au',
  'es-co': 'es-do',
  'es-ar': 'es-do',
  'es-mx': 'es',
  de: 'de',
  ja: 'ja',
  'en-gb': 'en-gb',
  'en-in': 'en-au',
  es: 'es',
  'zh-cn': 'zh-cn',
  'zh-hk': 'zh-hk',
  nl: 'nl',
  'en-au': 'en-au',
  'en-ca': 'en-ca',
  fi: 'fi',
  fr: 'fr',
  it: 'it',
  'pt-br': 'pt-br',
  sv: 'sv',
  da: 'da',
  pl: 'pl',
  cs: 'cs',
  ko: 'ko',
  no: 'nb',
  'no-no': 'nb',
  noNO: 'nb',
  'x-pseudo': 'x-pseudo',
  id: 'id',
  ro: 'ro',
  ru: 'ru',
  th: 'th',
  hr: 'hr',
  vi: 'vi',
  hu: 'hu',
  bn: 'bn',
  af: 'af',
  'ar-eg': 'ar',
  bg: 'bg',
  'ca-es': 'ca',
  sl: 'sl',
  tr: 'tr',
  uk: 'uk'
};
exports.momentMappings = momentMappings;

function setupTimezone(timezone) {
  if (!_I18n.default.moment) {
    return;
  }

  if (!timezone || !timezone.id) {
    // If we don't have portal data, then we can't use portalTz and even setting a timezone will cause issues
    // If no timezone data, then we should fall back to userTz
    // Without a timezone setting, portalTz returns undefined. So make portalTz work as userTz
    _I18n.default.moment.portalTz = _I18n.default.moment.userTz; // Fall back on some timezone to not break I18n.moment.fn.portalTz
    // TO DO - modify I18n.moment.fn.portalTz so that it doesn't break without I18n.timezone

    _I18n.default.timezone = 'US/Eastern';
    return;
  }

  if (_I18n.default.manualTimezone) {
    return;
  }

  var timezoneId = timezone.id;

  try {
    if (timezone['moment-data']) {
      if (!_I18n.default.moment.tz.zone(timezoneId)) {
        _I18n.default.moment.tz.add(timezoneId + "|" + timezone['moment-data']);
      }

      _I18n.default.moment.tz(timezoneId);

      _I18n.default.timezone = timezoneId;
    } else {
      if (Raven) {
        Raven.captureMessage("I18n failed to parse api-verify data: " + JSON.stringify(portal && portal.timezone));
      }
    }
  } catch (e) {
    console.error('Unable to set up timezone', e);

    if (Raven) {
      Raven.captureException(e);
    }
  }

  _I18n.default.timezone = _I18n.default.manualTimezone || window.I18N_RENDERED_TZ || _I18n.default.timezone;
}

function getValidLocale(locale) {
  var validLocale = (locale || defaultLanguage).toLowerCase();
  var fallbackLookup = languageMappings[validLocale] || languageMappings[validLocale.substring(0, 2)];

  if (fallbackLookup) {
    validLocale = fallbackLookup;
  }

  return validLocale || _I18n.default.locale;
}

function momentLocaleMapper(locale) {
  var validLocale = getValidLocale(locale);
  var localeMatch = validLocale;

  if (!momentMappings[localeMatch]) {
    localeMatch = null;
  } else {
    localeMatch = momentMappings[localeMatch];
  }

  return localeMatch;
}

function getLangEnabledLocales(locales) {
  return !_I18n.default.langEnabled ? [_I18n.default.locale].concat((0, _toConsumableArray2.default)(locales)) : locales;
}

function setManualOverwrites() {
  _I18n.default.manualLocale = window.I18N_MANUAL_LANG;
  _I18n.default.manualTimezone = window.I18N_TZ;

  try {
    var localeOverwrite = localStorage && localStorage.I18N_MANUAL_LANG;
    var timezoneOverwrite = localStorage && localStorage.I18N_TZ;
    _I18n.default.manualLocale = localeOverwrite;
    _I18n.default.manualTimezone = timezoneOverwrite;
  } catch (e) {
    _I18n.default.debugLog("Failed access localStorage " + e);
  }
}

function setHtmlLang() {
  var html = document.querySelector('html');
  html.className = html.className.replace(/(^|\b)lang-[a-z]{2}($|\b)/, '');
  html.className += " lang-" + (0, _getLang.default)();
  html.setAttribute('lang', (0, _getLangLocale.default)());
}